import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="privacy-container">
      <div className="overlay"></div>
      
      <div className="content-wrapper">
        <div className="privacy-content">
          {/* Header Section */}
          <header className="privacy-header">
            <h1>Privacy Policy</h1>
            <h2>Privacy Policy for <span className="brand-name">HomePlannner.com</span></h2>
          </header>

          {/* Main Content */}
          <main className="privacy-main">
            {/* Section 1 */}
            <section className="privacy-section">
              <h3>1. Information We Collect</h3>
              <p>
                We collect information that you voluntarily provide and information automatically collected.
              </p>
              <div className="subsection">
                <h4>Information You Provide:</h4>
                <ul>
                  <li>Name, email address, phone number, address</li>
                  <li>Project details: house plans, style preferences, budget, etc.</li>
                  <li>Payment info (only needed for processing; no full card storage)</li>
                </ul>
              </div>
              <div className="subsection">
                <h4>Automatically Collected Information:</h4>
                <ul>
                  <li>Usage data (pages visited, time spent on pages)</li>
                  <li>IP address, browser type, device type, OS</li>
                  <li>Cookies, log files, Google Analytics, remarketing pixels</li>
                </ul>
              </div>
            </section>

            {/* Section 2 */}
            <section className="privacy-section">
              <h3>2. How We Use Your Information</h3>
              <ul>
                <li>Provide and deliver Services (planning, consultation, etc.)</li>
                <li>Respond to inquiries and support requests</li>
                <li>Process payments securely</li>
                <li>Improve our website and services</li>
                <li>Send updates or marketing (only with consent)</li>
                <li>Maintain security and prevent fraud</li>
              </ul>
            </section>

            {/* Section 3 */}
            <section className="privacy-section">
              <h3>3. Disclosure of Your Information</h3>
              <ul>
                <li>With service providers (payment, hosting, etc.)</li>
                <li>With third parties (contractors/consultants) as needed</li>
                <li>When required by law (court/government)</li>
                <li>For fraud prevention</li>
                <li>With your consent</li>
              </ul>
            </section>

            {/* Section 4 */}
            <section className="privacy-section">
              <h3>4. Cookies and Tracking Technologies</h3>
              <ul>
                <li>We use cookies and similar technologies</li>
                <li>You can disable cookies in browser settings</li>
                <li>We may use Google Analytics, Facebook Pixel, etc.</li>
              </ul>
            </section>

            {/* Section 5 */}
            <section className="privacy-section">
              <h3>5. Data Security</h3>
              <ul>
                <li>We take reasonable measures to protect your information</li>
                <li>No method of transmission/storage is 100% secure</li>
              </ul>
            </section>
          </main>
        </div>
      </div>

      <style jsx>{`
        .privacy-container {
          position: relative;
          min-height: 100vh;
          background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 800"><rect fill="%23000" width="1200" height="800"/><g fill="%23333"><circle cx="200" cy="150" r="80" opacity="0.1"/><circle cx="800" cy="300" r="120" opacity="0.05"/><circle cx="1000" cy="600" r="100" opacity="0.08"/></g></svg>') center/cover;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 20px;
          font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
        }
        footer {
    display: block !important;
    /* top: 0; */
    bottom: 0;
    width: 100%;
    z-index: 9999;
}
        .overlay {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(135deg, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.5) 100%);
          z-index: 1;
        }

       .content-wrapper {
    position: relative;
    z-index: 2;
    width: 100%;
    max-width: 900px;
    max-height: 90vh;
    overflow-y: auto;
    scrollbar-width: thin;
    scrollbar-color: rgb(255 255 255 / 0%) transparent;
}

        .content-wrapper::-webkit-scrollbar {
          width: 6px;
        }

        .content-wrapper::-webkit-scrollbar-track {
          background: rgba(255, 255, 255, 0.1);
          border-radius: 3px;
        }

        .content-wrapper::-webkit-scrollbar-thumb {
          background: rgba(255, 255, 255, 0.3);
          border-radius: 3px;
        }

        .content-wrapper::-webkit-scrollbar-thumb:hover {
          background: rgba(255, 255, 255, 0.5);
        }

        .privacy-content {
          background: rgba(0, 0, 0, 0.9);
          backdrop-filter: blur(10px);
          border-radius: 16px;
          padding: 40px;
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.5);
          border: 1px solid rgba(255, 255, 255, 0.1);
        }

        .privacy-header {
          text-align: center;
          margin-bottom: 40px;
          border-bottom: 2px solid #4a5568;
          padding-bottom: 30px;
        }

        .privacy-header h1 {
          font-size: 2.5rem;
          font-weight: 700;
          color: #ffffff;
          margin: 0 0 15px 0;
          text-shadow: 0 2px 4px rgba(255, 255, 255, 0.1);
        }

        .privacy-header h2 {
          font-size: 1.25rem;
          font-weight: 500;
          color: #a0aec0;
          margin: 0;
        }

        .brand-name {
          font-weight: 700;
          color: #2d3748;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          -webkit-background-clip: text;
          background-clip: text;
          -webkit-text-fill-color: transparent;
        }

        .privacy-main {
          line-height: 1.7;
          color: #e2e8f0;
        }

        .privacy-section {
          margin-bottom: 35px;
          background: rgba(26, 32, 44, 0.6);
          border-radius: 12px;
          padding: 30px;
          border: 1px solid rgba(113, 128, 150, 0.3);
          transition: all 0.3s ease;
        }

        .privacy-section:hover {
          background: rgba(26, 32, 44, 0.8);
          transform: translateY(-2px);
          box-shadow: 0 8px 25px rgba(0, 0, 0, 0.3);
        }

        .privacy-section h3 {
          font-size: 1.5rem;
          font-weight: 600;
          color: #ffffff;
          margin: 0 0 20px 0;
          border-left: 4px solid #667eea;
          padding-left: 15px;
        }

        .privacy-section p {
          margin: 0 0 15px 0;
          font-size: 1rem;
          color: #cbd5e0;
        }

        .subsection {
          margin: 20px 0;
          padding: 20px;
          background: rgba(45, 55, 72, 0.5);
          border-radius: 8px;
          border: 1px solid rgba(113, 128, 150, 0.2);
        }

        .subsection h4 {
          font-size: 1.1rem;
          font-weight: 600;
          color: #f7fafc;
          margin: 0 0 12px 0;
        }

        ul {
          margin: 0;
          padding: 0 0 0 20px;
          list-style: none;
        }

        ul li {
          margin: 10px 0;
          padding-left: 20px;
          position: relative;
          color: #cbd5e0;
          font-size: 1rem;
        }

        ul li::before {
          content: "•";
          color: #667eea;
          font-weight: bold;
          position: absolute;
          left: 0;
          font-size: 1.2rem;
        }

        ul li:hover {
          color: #ffffff;
          transform: translateX(3px);
          transition: all 0.2s ease;
        }

        /* Responsive Design */
        @media (max-width: 768px) {
          .privacy-container {
            padding: 10px;
          }

          .privacy-content {
            padding: 25px;
            margin: 10px 0;
          }

          .privacy-header h1 {
            font-size: 2rem;
          }

          .privacy-header h2 {
            font-size: 1.1rem;
          }

          .privacy-section {
            padding: 20px;
            margin-bottom: 25px;
          }

          .privacy-section h3 {
            font-size: 1.3rem;
          }

          .subsection {
            padding: 15px;
          }
        }

        @media (max-width: 480px) {
          .privacy-header h1 {
            font-size: 1.8rem;
          }

          .privacy-header h2 {
            font-size: 1rem;
          }

          .privacy-section h3 {
            font-size: 1.2rem;
          }
        }
      `}</style>
    </div>
  );
};

export default PrivacyPolicy;